module.exports = __webpack_public_path__ + "img/hero-food.78ec96ef.png";